import styled, { css } from 'styled-components';
import { colors } from '../../variables/colors.js';
import { transitions } from '../../variables/transitions.js';

var CheckboxWrapper = styled.div.withConfig({
  displayName: "style__CheckboxWrapper",
  componentId: "sc-9rc1uf-0"
})(["", " ", "   ", ""], function (props) {
  return props.children && css(["display:flex;"]);
}, function (props) {
  return !props.children && css(["display:inline-block;"]);
}, function (props) {
  return props.focused && css(["outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;"]);
});
var Square = styled.span.withConfig({
  displayName: "style__Square",
  componentId: "sc-9rc1uf-1"
})(["align-items:center;background:", ";border:2px solid ", ";color:", ";display:inline-flex;flex-shrink:0;height:24px;justify-content:center;position:relative;transition:background ", ",border ", ";width:24px;", " ", ""], colors.white, colors.mediumGray, colors.white, transitions["default"], transitions["default"], function (props) {
  return props.checked && css(["background:", ";border-color:", ";", ""], colors.darkCore, colors.darkCore, props.theme === 'blue' && css(["background:", ";border-color:", ";"], colors.wave, colors.wave));
}, function (props) {
  return props.disabled && css(["background:", ";border-color:", ";"], colors.lightGray, colors.lightGray);
});
var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "sc-9rc1uf-2"
})(["cursor:pointer;display:flex;min-height:24px;position:relative;", " ", " .sg-checkbox-icon{position:absolute;height:16px;width:16px;left:4px;top:4px;z-index:1;fill:", "}"], function (props) {
  return props.disabled && css(["cursor:default;"]);
}, function (props) {
  return props.fullWidthLabel && css(["width:100%;"]);
}, colors.white);
var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-9rc1uf-3"
})(["display:inline;height:0;opacity:0;width:0;"]);
var Content = styled.span.withConfig({
  displayName: "style__Content",
  componentId: "sc-9rc1uf-4"
})(["align-items:center;display:inline-flex;line-height:20px;padding-left:10px;", ""], function (props) {
  return props.disabled && css(["opacity:.6;"]);
});

export { CheckboxWrapper, Content, Input, Label, Square };
//# sourceMappingURL=style.js.map
